import { z } from 'zod';

import { OrganizationUserType } from '../enums';
import {
  TrainerOnboardingAddressValidationDto,
  TrainerOnboardingContactValidationDto,
  TrainerOnboardingSocialMediaValidationDto,
} from './onboarding';

export const CreateTrainerDto = z
  .object({
    name: z
      .string()
      .min(3, 'VALIDATION__Min3CharLimit')
      .max(255, 'VALIDATION__Max255CharLimit'),
    email: z.string().trim().email(),
    address: TrainerOnboardingAddressValidationDto.optional(),
    contact: TrainerOnboardingContactValidationDto.optional(),
    socialMedia: TrainerOnboardingSocialMediaValidationDto.optional(),
  })
  .strict();

export type ApiCreateTrainerDto = z.infer<typeof CreateTrainerDto>;

export const UpdateTrainerDto = z
  .object({
    name: z
      .string()
      .min(3, 'VALIDATION__Min3CharLimit')
      .max(255, 'VALIDATION__Max255CharLimit')
      .optional(),
    roleIds: z.array(z.string().uuid()).nullable().optional(),
    address: TrainerOnboardingAddressValidationDto.optional(),
    contact: TrainerOnboardingContactValidationDto.optional(),
    socialMedia: TrainerOnboardingSocialMediaValidationDto.optional(),
  })
  .strict();

export type ApiUpdateTrainerDto = z.infer<typeof UpdateTrainerDto>;

export const UpdateRoleTrainerDto = z
  .object({
    roleIds: z.array(z.string().uuid()).nullable().optional(),
  })
  .strict();

export type ApiUpdateRoleTrainerDto = z.infer<typeof UpdateRoleTrainerDto>;

// `invite-trainer` mints staff-side memberships only. `type` used to be any
// string, written verbatim: with the shared invite seat rule (a CLIENT invite
// needs only a trainer seat) a free-form `CLIENT` here would let a trainer
// write a client row carrying arbitrary `roleIds`, past `invite-user`'s client
// door checks. Clients are invited through `invitations/invite-user`.
export const OrganizationTrainerInviteDto = z.object({
  email: z.string().trim().email(),
  roleIds: z.array(z.string().uuid()),
  type: z.enum([
    OrganizationUserType.TRAINER,
    OrganizationUserType.STAFF,
    OrganizationUserType.OWNER,
  ]),
});

export type ApiOrganizationTrainerInviteDto = z.infer<
  typeof OrganizationTrainerInviteDto
>;

export const AssignTrainerToClientDto = z.object({
  clientId: z.string().uuid(),
});

export type ApiAssignTrainerToClientDto = z.infer<
  typeof AssignTrainerToClientDto
>;
